export function calcWalletMonth(wallet, transactions, month, year) {
  const inMonth = (t) => { const d = new Date(t.date); return d.getMonth()===month && d.getFullYear()===year; };
  const txs = transactions.filter(inMonth);
  const incomeIn   = txs.filter(t => t.walletId===wallet.id && t.type==="income").reduce((a,t)=>a+t.amount,0);
  const transferIn = txs.filter(t => t.toWalletId===wallet.id && t.type==="transfer").reduce((a,t)=>a+t.amount,0);
  const expense     = txs.filter(t => t.walletId===wallet.id && (t.type==="expense"||t.type==="investasi")).reduce((a,t)=>a+t.amount,0);
  const transferOut = txs.filter(t => t.walletId===wallet.id && t.type==="transfer").reduce((a,t)=>a+t.amount,0);
  const budget  = incomeIn + transferIn;
  const usages  = expense + transferOut;
  return { budget, usages, balance: budget - usages };
}

export const computeInvested = (inv) => {
  if (inv.type === "saham_idx") return (inv.lot||0) * 100 * (inv.avgPrice||0);
  return (inv.unit||0) * (inv.avgPrice||0);
};

export const computeCurrent = (inv) => {
  if (inv.type === "saham_idx") return (inv.lot||0) * 100 * (inv.currentPrice||0);
  return (inv.unit||0) * (inv.currentPrice||0);
};

const PROXIES = [
  (url) => `/api/price?url=${encodeURIComponent(url)}`,
  (url) => `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`,
  (url) => `https://corsproxy.io/?url=${encodeURIComponent(url)}`,
];

async function fetchViaProxy(targetUrl) {
  for (const makeUrl of PROXIES) {
    try {
      const res = await fetch(makeUrl(targetUrl));
      if (!res.ok) continue;
      const text = await res.json().catch(() => null);
      if (text) return text;
    } catch { /* try next proxy */ }
  }
  return null;
}

const TROY_OZ_PER_GRAM = 31.1035;

export async function fetchPrice(inv) {
  try {
    // Crypto — CoinGecko
    if (inv.type === "crypto" && inv.coinId) {
      const direct = `https://api.coingecko.com/api/v3/simple/price?ids=${inv.coinId}&vs_currencies=idr`;
      try {
        const res  = await fetch(direct);
        const data = await res.json();
        if (data[inv.coinId]?.idr) return data[inv.coinId].idr;
      } catch { /* fallback to proxy */ }
      const data = await fetchViaProxy(direct);
      return data?.[inv.coinId]?.idr ?? null;
    }

    // Saham IDX / US — Yahoo Finance
    if ((inv.type === "saham_idx" || inv.type === "saham_us") && inv.ticker) {
      const ticker = inv.type === "saham_idx" ? `${inv.ticker.toUpperCase()}.JK` : inv.ticker.toUpperCase();
      const data   = await fetchViaProxy(`https://query1.finance.yahoo.com/v8/finance/chart/${ticker}?interval=1d&range=1d`);
      const price  = data?.chart?.result?.[0]?.meta?.regularMarketPrice;
      if (!price) return null;
      if (inv.type === "saham_us") {
        const fxData = await fetchViaProxy(`https://query1.finance.yahoo.com/v8/finance/chart/USDIDR=X?interval=1d&range=1d`);
        const rate   = fxData?.chart?.result?.[0]?.meta?.regularMarketPrice || 16000;
        return price * rate;
      }
      return price;
    }

    // Forex — kurs mata uang ke IDR
    if (inv.type === "forex" && inv.ticker) {
      const pair = `${inv.ticker.toUpperCase()}IDR=X`;
      const data = await fetchViaProxy(`https://query1.finance.yahoo.com/v8/finance/chart/${pair}?interval=1d&range=1d`);
      return data?.chart?.result?.[0]?.meta?.regularMarketPrice ?? null;
    }

    // Emas — XAUIDR=X (harga spot emas per troy oz dalam IDR) → konversi ke per gram
    if (inv.type === "emas") {
      const data = await fetchViaProxy(`https://query1.finance.yahoo.com/v8/finance/chart/XAUIDR=X?interval=1d&range=1d`);
      const pricePerOz = data?.chart?.result?.[0]?.meta?.regularMarketPrice;
      if (!pricePerOz) return null;
      return Math.round(pricePerOz / TROY_OZ_PER_GRAM);
    }

  } catch { return null; }
  return null;
}
